import { Reducer } from 'redux';
import {
  ForgotPasswordState,
  ForgotPasswordActionTypes,
  FORGOT_PASSWORD_REQUEST_INPROGRESS,
  FORGOT_PASSWORD_REQUEST_FAILURE,
  FORGOT_PASSWORD_REQUEST_SUCCESS,
} from './types';
import * as Bixby from '$/core';

const initialState: ForgotPasswordState = {
  isLoading: false,
  error: '',
  success: false,
};

const forgotPasswordReducer: Reducer<ForgotPasswordState> = (
  state = initialState,
  action: ForgotPasswordActionTypes
): ForgotPasswordState => {
  switch (action.type) {
    case FORGOT_PASSWORD_REQUEST_INPROGRESS:
      return {
        ...state,
        isLoading: true,
        error: '',
        success: false,
      };
    case FORGOT_PASSWORD_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: '',
        success: true,
      };
    case FORGOT_PASSWORD_REQUEST_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: Bixby.API.getErrorMessage((action.payload || {}) as Error),
        success: false,
      };
    default:
      return state;
  }
};
export default forgotPasswordReducer;
